import { Component, Input } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Globals } from 'projects/core/src/globals';
import { ModelList } from 'projects/core/src/include/modellist';
import { Filter, FilterMode, UserList } from 'projects/core/src/include/structures';
import { UserListService } from 'projects/core/src/lib/userlist.service';
import { UserlistComponent } from './detail/userlist.component';
import { NotificationService } from 'projects/core/src/lib/notification.service';
import { AddressesService } from 'projects/c1-backend/src/app/services/addresses.service';

@Component({
  selector: 'app-userlists',
  templateUrl: './userlists.component.html',
  styleUrl: './userlists.component.css'
})
export class UserlistsComponent extends ModelList<UserList> {

  @Input()
  table="";

  @Input()
  where_sql="";

  @Input()
  model_sql="";

  get currentUser(){
    return Globals.user;
  }

  filter_search:Filter=new Filter();

  constructor(
      private userlistsService: UserListService,
      private fb1: UntypedFormBuilder,
      private modalService:NgbModal
    ) {
      super(userlistsService,fb1);
      this.detailViewModal=UserlistComponent;
     }


  ngOnInit(): void {
      this.title='Gruppi anagrafiche';
      super.ngOnInit.apply(this, arguments); 
      this.getItems();
     
      this.filter_search.mode=FilterMode.like;
      this.filter_search.fields=[];
      this.filter_search.fields.push("ul.name");
      this.filter_search.value="";
      this.filter.push(this.filter_search);
  
  }

  override NewRecord(openDetailExtra=null):void{
      let name=prompt("Inserisci un nome da assegnare al gruppo");
      if(name!=""){
        const record:UserList=new UserList();
        record.name=name;
        record.table=this.table;
        record.model=this.model_sql;
        record.args=this.where_sql;
        this.userlistsService.save(record,()=>{
          this.getItems();
        })
      }
  }


  confirm_delete(record){
    Globals.modal.showConfirm("","Confermi di voler eliminare il gruppo " + record.name + "?",()=>{
      this.delete(record.id)
    },"Sì, elimina","No. Annulla","danger");
  }


  notify(record:UserList){
    const notificationService=new NotificationService();
    const addressesService=new AddressesService();

    this.userlistsService.getUsersByIdList(record.id).subscribe((result)=>{
      let ids_address=[];
      for(let r of result){
        ids_address.push(r.id);
      }
      addressesService.getAddressesByIds(ids_address).subscribe((result2)=>{
        const addresses=result2;
          notificationService.showPreviewNotification([],{},record.table,()=>{
          
        },ids_address,0,addresses);
      });
    });   
      
  }


}
